import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';

/**
 * Shown when the current user does not have access to a requested resource.
 * Matches FAIM I's NoAccess → 404 pattern: user can navigate away but not
 * see the protected data.
 */
export function NoAccessPage() {
  const navigate = useNavigate();

  return (
    <main className="max-w-[1440px] mx-auto px-6 py-16 flex flex-col items-center gap-4">
      <Typography variant="h1" component="h1" align="center">
        Access Denied
      </Typography>
      <Typography variant="body1" color="text.secondary" align="center">
        You do not have access to this resource, or it does not exist.
      </Typography>
      <Button
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        sx={{ mt: 2 }}
      >
        Go Back
      </Button>
    </main>
  );
}
